import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=6f2a995d&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=6f2a995d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2a995d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/atlassian/application-data/bamboo/local-working-dir/AG-FRTPRSTD0-JOBCOMPILAR/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f2a995d')) {
      api.createRecord('6f2a995d', component.options)
    } else {
      api.reload('6f2a995d', component.options)
    }
    module.hot.accept("./Statistics.vue?vue&type=template&id=6f2a995d&scoped=true", function () {
      api.rerender('6f2a995d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Statistics.vue"
export default component.exports